import React, { Component, Fragment } from 'react';
import { createGlobalStyle } from 'styled-components';
import VideoContainer from './components/VideoContainer';

const GlobalStyle = createGlobalStyle`
* {
  box-sizing: border-box;
}
 body {
  font-family: 'Work Sans', sans-serif;
 }
`;

class App extends Component {
  render() {
    return (
      <Fragment>
        <GlobalStyle />
        <VideoContainer />
      </Fragment>
    );
  }
}

export default App;
